import styled from 'styled-components';

interface Props {
  variant: 'filled' | 'clean';
  backgroundColor?: string;
  color?: string;
}

export const Container = styled.button<Props>`
  display: flex;
  align-items: center;
  padding: 5px 10px;
  transition: all ease-in-out 0.2s;
  cursor: pointer;
  border-radius: 5px;
  gap: 5px;
  width: fit-content;
  font-weight: 500;
  font-size: 12px;
  border: none;

  ${(props) =>
    props.variant === 'filled' &&
    `
      color: ${props.theme.colors.primary};
      background-color: ${props.theme.colors.primaryLight};
    `};

  ${(props) =>
    props.variant === 'clean' &&
    `
      color: ${props.theme.colors.text};
      background-color: transparent;
    `};

  ${(props) =>
    props.backgroundColor &&
    `
      color: ${props.theme.colors.text};
      background-color: ${props.backgroundColor};
    `};

  ${(props) =>
    props.color &&
    `
      color: ${props.color};
    `};

  &:hover {
    transition: all ease-in-out 0.2s;
    color: ${(props) =>
      props.backgroundColor
        ? props.theme.colors.text
        : props.theme.colors.primary};
    background-color: ${(props) =>
      props.backgroundColor ?? props.theme.colors.primaryLight};
  }

  svg {
    font-size: 16px;
    background-color: transparent;

    ${(props) =>
      props.variant === 'filled' &&
      `
      color: ${props.theme.colors.primary};
    `};

    ${(props) =>
      props.variant === 'clean' &&
      `
      color: ${props.theme.colors.text};
    `};

    ${(props) =>
      props.backgroundColor &&
      `
      color: ${props.theme.colors.text};
    `};
  }
`;
